// extracted by mini-css-extract-plugin
export default {"header":"SettingsHeader_header__hMsYe","text":"SettingsHeader_text__Nb3yM","buttonCont":"SettingsHeader_buttonCont__c-5j3"};